import TemplateView from '../TemplateView'

export default class BalanceRulesEditorContent extends TemplateView {
    constructor({
        balanceRulesEditorComponent = null,
        leaveBalanceTypePrefix = '',
    }) {
        super()
        this.props = {
            balanceRulesEditorComponent,
            leaveBalanceTypePrefix,
        }
    }

    templateHtml() {
        return "<div id='<%=leaveBalanceTypePrefix%>_modifyBalanceAccrualRules' class='modifyBalanceAccrualRules'>" +
               "    <table cellspacing='0' cellpadding='0' id='<%=leaveBalanceTypePrefix%>_accruaRulesTable' class='accrualRulesTable'>" +
               "        <tr>" +
               "            <td class='ruleCheckbox'><input type='checkbox' class='resetRuleCheckbox' id='<%=leaveBalanceTypePrefix%>_resetRuleCheckbox'></td>" +
               "            <td>" +
               "                <table cellspacing='0' cellpadding='0' id='<%=leaveBalanceTypePrefix%>_resetRuleTable' class='resetRuleTable ruleTable'>" +
               "                    <tr>" +
               "                        <td><label for='<%=leaveBalanceTypePrefix%>_resetRuleCheckbox' id='<%=leaveBalanceTypePrefix%>_resetRuleLabel'><%=resetRule%></label></td>" +
               "                        <td><input type='text' class='days' id='<%=leaveBalanceTypePrefix%>_resetBalanceField' size='3'> </td>" +
               "                        <td><span class='days'><%=unitsDaysShort%></span><span class='hours'><%=unitsHoursShort%></span> </td>" +
               "                        <td>" +
               "                            <div id='<%=leaveBalanceTypePrefix%>_resetPeriodSelectPlaceholder'></div>" +
               "                        </td>" +
               "                        <td id='<%=leaveBalanceTypePrefix%>_resetOn' class='resetOn'><%=editorOn%></td>" +
               "                        <td></td>" +
               "                        <td>" +
               "                            <div id='<%=leaveBalanceTypePrefix%>_resetMonthSelectPlaceholder'></div>" +
               "                        </td>" +
               "                        <td>" +
               "                            <div id='<%=leaveBalanceTypePrefix%>_resetMonthDaySelectPlaceholder'></div>" +
               "                        </td>" +
               "                    </tr>" +
               "                </table>" +
               "                <span class='readOnly readOnlyResetRule' id='<%=leaveBalanceTypePrefix%>_readOnlyResetRule'></span>" +
               "            </td>" +
               "        </tr>" +
               "        <tr>" +
               "            <td class='ruleCheckbox'><input type='checkbox' class='accrueRuleCheckbox' id='<%=leaveBalanceTypePrefix%>_accrueRuleCheckbox'></td>" +
               "            <td>" +
               "                <table cellspacing='0' cellpadding='0' id='<%=leaveBalanceTypePrefix%>_accrueRuleTable' class='accrueRuleTable ruleTable '>" +
               "                    <tr>" +
               "                        <td><label for='<%=leaveBalanceTypePrefix%>_accrueRuleCheckbox' id='<%=leaveBalanceTypePrefix%>_accrualRuleLabel'><%=accrueRule%></label></td>" +
               "                        <td><input type='text' class='days' id='<%=leaveBalanceTypePrefix%>_accrueBalanceField'></td>" +
               "                        <td><span class='days'><%=unitsDaysShort%></span><span class='hours'><%=unitsHoursShort%></span></td>" +
               "                        <td>" +
               "                            <div id='<%=leaveBalanceTypePrefix%>_accruePeriodSelectPlaceholder'></div>" +
               "                        </td>" +
               "                        <td id='<%=leaveBalanceTypePrefix%>_accrueOn' class='accrueOn'><%=editorOn%></td>" +
               "                        <td>" +
               "                            <div id='<%=leaveBalanceTypePrefix%>_accrueWeekdaySelectPlaceholder'></div>" +
               "                        </td>" +
               "                        <td>" +
               "                            <div id='<%=leaveBalanceTypePrefix%>_accrueMonthSelectPlaceholder'></div>" +
               "                        </td>" +
               "                        <td>" +
               "                            <div id='<%=leaveBalanceTypePrefix%>_accrueMonthDaySelectPlaceholder'></div>" +
               "                        </td>" +
               "                        </td>" +
               "                    </tr>" +
               "                </table>" +
               "                <span class='readOnly readOnlyAccrualRule' id='<%=leaveBalanceTypePrefix%>_readOnlyAccrueRule'></span>" +
               "            </td>" +
               "        </tr>" +
               "        <tr>" +
               "            <td class='ruleCheckbox'><input type='checkbox' class='capRuleCheckbox' id='<%=leaveBalanceTypePrefix%>_capRuleCheckbox'></td>" +
               "            <td>" +
               "                <table cellspacing='0' cellpadding='0' id='<%=leaveBalanceTypePrefix%>_capRuleTable' class='capRuleTable ruleTable'>" +
               "                    <tr>" +
               "                        <td><label for='<%=leaveBalanceTypePrefix%>_capRuleCheckbox' id='<%=leaveBalanceTypePrefix%>_capRuleLabel'><%=capRule%></label></td>" +
               "                        <td><input type='text' class='days' id='<%=leaveBalanceTypePrefix%>_capBalanceField' size='3'> " +
               "                            <span class='readOnly' id='readOnlyCapValueSelect' ></span>" +
               "                            <span class='days'><%=unitsDaysShort%></span>" +
               "                            <span class='hours'><%=unitsHoursShort%></span></td>" +
               "                    </tr>" +
               "                </table>" +
               "                <span class='readOnly readOnlyCapRule' id='<%=leaveBalanceTypePrefix%>_readOnlyCapRule'></span>" +
               "            </td>" +
               "        </tr>" +
               "    </table>" +
               "</div>"
    }

    templateModel() {
        return {
            leaveBalanceTypePrefix: this.props.leaveBalanceTypePrefix,
        }
    }

    messageKeys() {
        return {
            resetRule: 'balance_editor.balance_rules.reset_rule.label',
            accrueRule: 'balance_editor.balance_rules.accrual_rule.label',
            unitsDaysShort: 'common.balance_units.days.short',
            unitsHoursShort: 'common.balance_units.hours.short',
            editorOn: 'balance_editor.on',
            capRule: 'balance_editor.balance_rules.cap_rule.label',
        }
    }

    afterRender() {
        if (this.props.balanceRulesEditorComponent !== null) {
            this.props.balanceRulesEditorComponent.init()
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/controls/BalanceRulesEditorContent.js